package top.wcpe.allincore.ui.web.docs

import top.wcpe.allincore.ui.web.asset.PreviewDependencyRegistry

// 浏览器 UI 博物馆 / 组件文档共用依赖登记表。
// alias：scanner 按 import as 名解析 wiki 壳与文档组件。
// bareNames：theme.scheme 裸名解析到 ui-themes 下 .allin 主题文件。
// 路径均为 dist 内逻辑相对路径，由 previewDist/docsDist 打包保证存在。
internal object WikiMuseumDependencyRegistry {

    private const val COMPONENTS_PREFIX = "components-source/ui-components/"
    private const val THEMES_PREFIX = "ui-themes/"

    private val ALIAS_TO_PATH: Map<String, String> = mapOf(
        "PrimaryButton" to path("PrimaryButton.allin"),
        "SecondaryButton" to path("SecondaryButton.allin"),
        "Card" to path("Card.allin"),
        "FormField" to path("FormField.allin"),
        "InventoryGrid" to path("InventoryGrid.allin"),
        "LoadingRing" to path("loading/Ring.allin"),
        "CanvasRing" to path("canvas-loading/CanvasRing.allin"),
        "MinimapHud" to path("minimap/MinimapHud.allin"),
        "MinimapCanvas" to path("minimap/MinimapCanvas.allin"),
        "TasksPage" to path("activity/pages-inline/TasksPage.allin"),
        "WikiShell" to path("wiki/WikiShell.allin"),
        "WikiToolbar" to path("wiki/WikiToolbar.allin"),
        "WikiTabs" to path("wiki/WikiTabs.allin"),
        "WikiCategoryRail" to path("wiki/WikiCategoryRail.allin"),
        "NativeControlsPage" to path("wiki/pages/NativeControlsPage.allin"),
        "LibraryControlsPage" to path("wiki/pages/LibraryControlsPage.allin"),
        "ThemeTokensPage" to path("wiki/pages/ThemeTokensPage.allin"),
        "LegacyCasesPage" to path("wiki/pages/LegacyCasesPage.allin"),
        "ThemePicker" to path("wiki/theme/ThemePicker.allin"),
        "ChoiceChip" to path("wiki/theme/ChoiceChip.allin"),
        "ThemeTokenMatrix" to path("wiki/theme/ThemeTokenMatrix.allin"),
    )

    private val THEME_BARE_NAMES: Map<String, String> = listOf(
        "Default",
        "AntDesign",
        "Arco",
        "Arwes",
        "BrandCompact",
        "Md3Dark",
        "Md3DarkCompact",
        "Md3HighContrast",
        "Md3Light",
        "Md3LightCompact",
    ).associateWith { name -> THEMES_PREFIX + name + ".allin" }

    /** 预览编译时始终注入的全部主题源路径（保证 ThemePicker 有完整目录）。 */
    val allThemePaths: List<String>
        get() = THEME_BARE_NAMES.values.toList()

    fun create(): PreviewDependencyRegistry =
        PreviewDependencyRegistry(
            aliases = ALIAS_TO_PATH.mapValues { (_, p) -> listOf(p) },
            bareNames = THEME_BARE_NAMES.mapValues { (_, p) -> listOf(p) },
        )

    private fun path(relativeUnderUiComponents: String): String =
        COMPONENTS_PREFIX + relativeUnderUiComponents
}
